import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import ChangeProduct from '../../../forms/changeProduct/ChangeProduct';
import MotiveTitle from '../MotiveTitle';
import ProductColorIcon from '../../../../../../../common/icons/icr_preparando_pedido.svg';

const ChangeProductMobile = ({ ...props }) => {
  const {
    motiveId,
    product,
    orderId,
    sku,
    profile,
    type,
    validationStatus,
    validation,
    onData,
  } = props;
  return (
    <Box>
      <MotiveTitle
        icon={ProductColorIcon}
        title="Producto"
        subtitle="Cambio de producto"
        mobile
      />
      <ChangeProduct
        mobile
        motiveId={motiveId}
        orderId={orderId}
        sku={sku}
        product={product}
        profile={profile}
        type={type}
        validationStatus={validationStatus}
        validation={validation}
        onData={onData}
      />
    </Box>
  );
};

ChangeProductMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  validationStatus: PropTypes.string,
  validation: PropTypes.object,
  onData: PropTypes.func,
  sku: PropTypes.string,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ChangeProductMobile;
